(() => {
  if (window.esenzaLegalGuaranteeReady) return;
  window.esenzaLegalGuaranteeReady = true;
  let opener;
  let previousOverflow;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-legal-guarantee]');
    const dialog = document.getElementById('EsenzaLegalGuarantee');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (trigger) {
      event.preventDefault();
      if (dialog.open) return;
      opener = trigger;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      dialog.scrollTop = 0;
      document.body.style.overflow = 'hidden';
    } else if (event.target.closest('[data-legal-guarantee-close]')) {
      dialog.close();
    } else if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.id !== 'EsenzaLegalGuarantee') return;
    document.body.style.overflow = previousOverflow || '';
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  }, true);
})();
